class ValidatorException extends Error {}

export default ValidatorException;
